/**
 * Converts a file size in bytes to a human-readable string.
 *
 * @param bytes - The file size in bytes.
 * @param decimalPoint - The number of decimal points to include (default is 2).
 * @returns A string representing the human-readable file size.
 *
 * Example:
 * Input: normalizeFileSize(1024, 2)
 * Output: "1 KB"
 */
export const normalizeFileSize = (bytes: number = 0, decimalPoint: number = 2): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimalPoint;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
